// extracted by mini-css-extract-plugin
module.exports = {"update-button":"Button_update-button__3R0K2"};